"use client";

import type { ReactNode } from "react";
import TagManager from "react-gtm-module";

export function NewsletterSignUpClient(props: { listUrl?: string; children: ReactNode }) {
	const { listUrl, children } = props;

	return (
		<form
			action={listUrl}
			method="POST"
			target="_blank"
			onSubmit={() => {
				TagManager.dataLayer({ dataLayer: { event: "subscribe_newsletter" } });
			}}
		>
			{children}
		</form>
	);
}
